import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ViewTableComponent } from "./view-table/view-table.component";
import { CommonMaterialModule } from "@nrwl/common-material";
import { CommonLibModule } from "@nrwl/common-lib";
import { StatePreviewModule } from "@nrwl/state-preview";


@NgModule({
  imports: [CommonModule, CommonMaterialModule, CommonLibModule,StatePreviewModule],
  declarations: [ViewTableComponent],
  exports: [ViewTableComponent]
})
export class ViewTableModule {}
